module.exports = __webpack_public_path__ + "static/media/14UNEP25.5c44a573.jpg";